import { Component, AfterViewInit } from '@angular/core';
import { RouterLink } from '@angular/router';

declare var WOW: any;
declare var $: any;
declare var Swiper: any;

@Component({
  standalone: true,
  selector: 'app-home',
  imports: [RouterLink],
  templateUrl: './home.component.html'
})
export class HomeComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    setTimeout(() => {

      // WOW animation
      if (typeof WOW !== 'undefined') {
        new WOW().init();
      }

      // Magnific popup
      if ($('.popup-link').length) {
        $('.popup-link').magnificPopup({
          type: 'image'
        });
      }

      // Initialize Services Swiper Carousel
      if (typeof Swiper !== 'undefined' && $('.services-carousel').length) {
        const swiperEl = $('.services-carousel')[0] as any;
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
        new Swiper('.services-carousel', {
          loop: true,
          freeMode: false,
          grabCursor: true,
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            nextEl: '.services-button-next',
            prevEl: '.services-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            }
          }
        });

        // Hover Active Init for Products Cards (using event delegation for Swiper loops)
        $('.services-carousel').on('mouseenter', '.hover-active-item', function(this: any) {
          const $this = $(this);
          if (!$this.hasClass('active')) {
            $this.addClass('active');
            $this.siblings().removeClass('active');
          }
        });
      }
    }, 200);
  }
}
